import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { profileUpdateApi } from "./profile.component.service";
import { getProfileFormInputs } from "./constants/profile-form.constants";
import ProfileTemplate from "./profile-template";
import { setUserTokenAction } from "@reducers/app.reducer";
const menuUrl = "profile";
const {
  ALERT_TYPES: { SUCCESS, ERROR },
  PROFILE_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const ProfileComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formInputs, setFormInputs] = useState([]);
  const { user, token } = useSelector((state) => state.app);
  const [data, setData] = useState(user || {});

  console.log({ data });
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let payload = {};
    for (let i = 0; i < values.length; i++) {
      payload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const response = await profileUpdateApi(payload);
    console.log({ response });
    // INFO : check api response and show relevant alert message
    if (response.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));

      dispatch(
        setUserTokenAction({ token: token, user: { ...user, ...payload } })
      );
      history.push(`/${menuUrl}`);
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: response.message }));
    }
  };
  const onLoad = async () => {
    const formInputData = getProfileFormInputs({
      name: user?.name || "",
      email: user?.email || "",
      mobile: user?.mobile || "",
      dob: user?.dob || "",
      profileImage: user?.profile_image || "",
    });
    setFormInputs(formInputData);
  };

  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    formInputs,
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return (
    <ProfileTemplate
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  );
};

export default ProfileComponent;
